// Implements: F-UIX-009
/** The brand row of the recovery cards (v3 `authBrand`), the same as the login card's. */

import type { ReactElement } from "react";

import { useTranslation } from "../../../shared/i18n";
import { Icon } from "../../../shared/ui/atoms/Icon";
import login from "./LoginForm.module.css";

export function RecoveryBrand(): ReactElement {
  const { t } = useTranslation();
  return (
    <div className={login.brand}>
      <span className={login.logo}>
        <Icon name="mark" size="sm" />
      </span>
      {t("app.shell.brand")}
    </div>
  );
}
